import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';

import { DeactivationGuarded } from "../models/auth-guard/deactivation-guarded";

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<DeactivationGuarded> {
    canDeactivate(component: DeactivationGuarded): Observable<boolean> | Promise<boolean> | boolean {
        return component.canDeactivate ? component.canDeactivate() : true;
    }
}
